import { useState } from 'react';

export default function WhatsAppFloating() {
  const [expanded, setExpanded] = useState(false);

  const phoneNumber = '5554996542326';
  const defaultMessage = 'Olá! Vim pelo site https://wzappro.com/ e gostaria de mais informações sobre os planos e orçamentos.';
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(defaultMessage)}`;

  return (
    <div className="fixed bottom-6 right-6 z-[100] flex flex-col items-end gap-3">
      {/* Expanded chat bubble */}
      {expanded && (
        <div className="animate-slideUp bg-white dark:bg-background-100 rounded-2xl border border-background-200 dark:border-background-300 shadow-[0_8px_40px_rgba(0,0,0,0.12)] p-5 w-[300px]">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2.5">
              <div className="w-9 h-9 rounded-full bg-[#25D366] flex items-center justify-center">
                <i className="ri-whatsapp-fill text-white text-lg" />
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-900 dark:text-foreground-100">WZap PRO</p>
                <p className="text-[11px] text-foreground-500">Responde em minutos</p>
              </div>
            </div>
            <button
              onClick={() => setExpanded(false)}
              className="w-7 h-7 flex items-center justify-center rounded-lg text-foreground-400 hover:text-foreground-600 hover:bg-background-100 dark:hover:bg-background-200 transition-colors cursor-pointer"
            >
              <i className="ri-close-line" />
            </button>
          </div>
          <div className="bg-[#dcf8c6] dark:bg-emerald-500/20 rounded-xl rounded-tl-sm p-3 mb-4">
            <p className="text-sm text-foreground-800 dark:text-foreground-200 leading-relaxed">
              Olá! 👋 Como podemos ajudar? Fale diretamente com nossa equipe de vendas e suporte pelo WhatsApp.
            </p>
          </div>
          <div className="flex flex-col gap-2">
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2.5 w-full px-4 py-2.5 bg-[#25D366] hover:bg-[#22c35e] text-white text-sm font-semibold rounded-xl transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-fill text-lg" />
              Solicitar Orçamento
            </a>
            <a
              href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent('Olá! Preciso de suporte técnico.')}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2.5 w-full px-4 py-2.5 bg-background-100 dark:bg-background-200 hover:bg-background-200 dark:hover:bg-background-300 text-foreground-700 dark:text-foreground-300 text-sm font-medium rounded-xl transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-customer-service-2-line" />
              Suporte Técnico
            </a>
          </div>
        </div>
      )}

      {/* Floating button */}
      <button
        onClick={() => setExpanded(!expanded)}
        className={`w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer relative ${
          expanded
            ? 'bg-foreground-800 dark:bg-foreground-200 rotate-45'
            : 'bg-[#25D366] hover:bg-[#22c35e] animate-bounce-subtle'
        }`}
        aria-label="WhatsApp"
      >
        <i
          className={`text-white text-2xl transition-all duration-300 ${
            expanded ? 'ri-close-line' : 'ri-whatsapp-fill'
          }`}
        />
        {!expanded && (
          <span className="absolute top-0 right-0 w-3.5 h-3.5 bg-red-500 rounded-full border-2 border-white dark:border-background-100 animate-pulse" />
        )}
      </button>
    </div>
  );
}